import React, { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import './CookieConsentBanner.css'

const CookieConsentBanner = () => {
  const [cookies, setCookie] = useCookies(['cookieConsent']);
  const [isVisible, setIsVisible] = useState(!cookies.cookieConsent);

  const handleAcceptCookies = () => {
    setCookie('cookieConsent', true, { path: '/', maxAge: 2592000 }); // 30 días
    setIsVisible(false);
  };

  useEffect(() => {
    if (cookies.cookieConsent) {
      setIsVisible(false);
    }
  }, [cookies]);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookie-banner">
      <p>Este sitio web utiliza cookies para mejorar la experiencia del usuario. Al continuar navegando, aceptas su uso.</p>
      <button onClick={handleAcceptCookies}>Aceptar</button>
    </div>
  );
};

export default CookieConsentBanner;
